module.exports = __webpack_public_path__ + "img/KIENLONGBANK.ccd2b72f.svg";